import {connect} from 'react-redux';
import axios from 'axios';
import store from "../../../../redux/store";
import SplashSatiaScreen from '../../../satia/splash/SplashSatiaScreen';
import {
    typeExport
} from "../../../../redux/store/type";
import {Platform} from "react-native";
import {Tools} from "../../../../tools/Tools";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";

const mapStateToProps = (state) => ({
    // results_City: state.reducerSplashSatiaScreen.results_City,
    results: state.reducerSplashSatiaScreen.results,
    NoInternetDialog: state.reducerSplashSatiaScreen.NoInternetDialog,
    isLoading: state.reducerSplashSatiaScreen.isLoading,
    token: state.reducerSplashSatiaScreen.token,
    beginDate: state.reducerSplashSatiaScreen.beginDate,
    endDate: state.reducerSplashSatiaScreen.endDate,
    indexSelectMonthType: state.reducerSplashSatiaScreen.indexSelectMonthType,

    /*    NoInternetDialogShahrdar: state.reducerSplashSatiaScreen.NoInternetDialogShahrdar,
        isLoadingShahrdar: state.reducerSplashSatiaScreen.isLoadingShahrdar,
        resultsShahrdar: state.reducerSplashSatiaScreen.resultsShahrdar,*/


    isLoadingSatia: false,
    resultsSatia: state.reducerSplashSatiaScreen.resultsSatia,
    NoInternetDialogSatia: state.reducerSplashSatiaScreen.NoInternetDialogSatia,
    showDialohCity: state.reducerSplashSatiaScreen.showDialohCity,
    error: state.reducerSplashSatiaScreen.error,
    user: state.reducerSplashSatiaScreen.user,

    idCity: state.reducerSplashSatiaScreen.idCity,
    StoreName: state.reducerSplashSatiaScreen.StoreName,
    Rtl: state.reducerSplashSatiaScreen.Rtl,
    Lang: state.reducerSplashSatiaScreen.Lang,
    token_fb: state.reducerSplashSatiaScreen.token_fb,
    Background: state.reducerSplashSatiaScreen.Background,
    STATE: state.reducerSplashSatiaScreen.STATE,
    Connection: state.reducerSplashSatiaScreen.Connection,
    Location: state.reducerSplashSatiaScreen.Location,
    TypeLogin: state.reducerSplashSatiaScreen.TypeLogin,
    wallet: state.reducerSplashSatiaScreen.wallet,

    wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
    wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,
    ConnectionInternetHotspot: state.reducerSplashSatiaScreen.ConnectionInternetHotspot,

});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (params, type, typeConnection, RequestElse) => dispatch(callWebservice(params, type, typeConnection, RequestElse)),
    callServiceSuccess: (data, token, user) => dispatch(serviceActionSuccess(data, token, user)),
    callServiceSuccessSatia: (data, token, user) => dispatch(serviceActionSuccessSatia(data, token, user)),
    callServiceSetTypeLogin: (data, token, user) => dispatch(serviceActionSetTypeLogin(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),
    callServiceSetIdCity: (data) => dispatch(serviceActionSetIdCity(data)),
    callServiceAddCart: (data, methd) => dispatch(serviceActionAddCart(data, methd)),
    callServiceSubCart: (data) => dispatch(serviceActionSubCart(data)),
    callServiceRtl: (data) => dispatch(serviceActionRtl(data)),
    callServiceLang: (data) => dispatch(serviceActionLang(data)),
    callServiceBackground: (data) => dispatch(serviceActionBackground(data)),
    callServiceChangeNotifUser: (data) => dispatch(serviceActionChangeNotifUser(data)),
    callServiceTokenFirebase: (data) => dispatch(serviceActionTokenFirebase(data)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceError: (data) => dispatch(serviceActionError(data)),
    callServiceSetLocation: (data) => dispatch(serviceActionSetLocation(data)),
    callServiceSetTimeSpan: (beginDate, endDate, indexSelectMonthType, month) => dispatch(serviceActionSetTimeSpan(beginDate, endDate, indexSelectMonthType, month)),

})

const getDataDisatch = (dispatch, params, type, typeConnection, RequestElse) => {
//alert()
    let {token, token_fb, Account, TypeLogin} = params ? params : store.getState()

    switch (type) {
        case typeExport.TypeGetAllData:
            //if (!RequestElse)
            dispatch(serviceActionPending());
            break;


        default:
    }


    let formData = new FormData();

    // formData.append(customer, params.customer ? JSON.stringify(params.customer) : null);
    formData.append('customer', Account ? JSON.stringify(Account) : null);

    formData.append('token', token == null ? '' : token);
    formData.append('beginDate', params.beginDate == null ? '' : params.beginDate);
    formData.append('endDate', params.endDate == null ? '' : params.endDate);

    // formData.append('token_fb', token_fb == null ? '' : token_fb);
    //formData.append('lang', "fa");

    Tools.DeviceInfo(formData)

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // crossdomain: true,
            // 'Access-Control-Allow-Origin': '*',
            /*         'Access-Control-Allow-Origin': '*',// to enable calls from every domain
                     'Access-Control-Allow-Methods': 'OPTIONS, GET, POST, PUT, PATCH, DELETE', // allowed actiosn
                     'Access-Control-Allow-Headers': 'Content-Type, Authorization',*/

            // 'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Origin': 'http://localhost:3000',
            //  'Access-Control-Allow-Credentials': 'true'
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        },
        //    withCredentials: true,

        timeout: typeExport._TIMEOUT,
    };

    switch (type) {

        case typeExport.TypeGetAllData:

            // axios({
            //     method: 'post',
            //     url: typeExport._baseUrlSatia + "splash",
            //     data: formData,
            //     headers: {'Content-Type': 'multipart/form-data'},
            //     timeout: typeExport._TIMEOUT,
            //
            // })
            axios.post(typeExport._baseUrlSatia + (typeExport._NameApp === "SatiaOperator" ? "operator_tk/splash" : "splash"), formData, config)
                .then(async response => {
                    let data = response.data;
                    //  alert("hj")

                    if (response.data.status) {
                        global._loadDataCount = 1;
                        let user = response.data.user;
                        // dispatch(serviceActionSuccessSatia(data));
                        if (user.token && user && user.token.length > 0) {
                            dispatch(serviceActionSetToken(user.token));
                            dispatch(serviceActionSetUser(user));
                            if (user && user.customer && user.customer.wallet && user.customer.wallet >= 0)
                                dispatch(serviceActionSetWallet(user.customer.wallet));
                            // await AsyngStorageClass.setAsyng(typeExport._USER, user);

                        } else {
                            dispatch(serviceActionSetToken(null));
                        }
                        //dispatch(serviceActionTokenFirebase(params.token_fb));

                        dispatch(serviceActionSuccess(data));
                        dispatch(serviceActionBackground(null));


                        //   dispatch(serviceActionBackground(imageBackground));

                        // if (RequestElse != undefined && data.menus) {
                        //     let dataSplash = store.getState().reducerSplashSatiaScreen
                        //     //  await AsyngStorageClass.setAsyng("splash" + global.IdCity, data);
                        //     // if (dataSplash.resultsSatia.status) {
                        //     await AsyngStorageClass.setAsyng("splashSatia" + global.IdCity, data);
                        //     //}
                        // }

                        if (!RequestElse) {

                            /*    try {
                                    NavigationService.navigatereset('DrawerSatia')

                                }
                                catch (e) {
                                    NavigationService.resetTo('DrawerSatia')

                                }*/
                        }


                    }
                    else {
                        if (response.data.exit) {
                            AsyngStorageClass.removeToken();
                            dispatch(serviceActionSuccess(null));
                            // Tools.remove();
                            //  NavigationService.resetTo('LoginSatiaStack');

                        }
                        dispatch(serviceActionError(response))
                        // if (!RequestElse) {
                        //     dispatch(serviceActionError("e"));
                        //     NavigationService.navigatereset('LoginSatiaStack')
                        //
                        // } else {

                        //}

                    }

                }).catch((e) => {
                //    if (!RequestElse)
                dispatch(serviceActionError(e))

            })
            break;
        default:
            dispatch(serviceActionError('not exit :  ' + type));
    }

}

export const callWebservice = (params, type, typeConnection, RequestElse) => {
    // alert("hjjhjh")
    return dispatch => {
        getDataDisatch(dispatch, params, type, typeConnection, RequestElse);
    }
}

export const serviceActionPending = () => ({
    type: typeExport.SPLASH_SATIA_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    error: false,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.SPLASH_SATIA_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false,
    resultsSatia: error

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.SPLASH_SATIA_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,

    /*  token: token,
      user: user,*/
    isLoading: false,
})
export const serviceActionPendingSatia = () => ({
    type: typeExport.SPLASH_SATIA_SERVICE_PENDING_Satia,
    NoInternetDialogSatia: false,
    isLoadingSatia: true,
    error: false,

})

export const serviceActionErrorSatia = (error) => ({
    type: typeExport.SPLASH_SATIA_SERVICE_ERROR_Satia,
    NoInternetDialogSatia: true,
    error: error,
    isLoadingSatia: false,

})

export const serviceActionSuccessSatia = (data) => ({
    type: typeExport.SPLASH_SATIA_SERVICE_SUCCESS_Satia,
    NoInternetDialogSatia: false,
    resultsSatia: data,
    /*    token: token,
        user: user,*/
    isLoadingSatia: false,
})

export const serviceActionRefresh = () => ({
    type: typeExport.SPLASH_SATIA_SERVICE_REFRESH,
    NoInternetDialog: false,
    error: false,
    isLoading: false,
    results: null,

    resultsShahrdar: null,
    NoInternetDialogShahrdar: false,
    isLoadingShahrdar: false,

    resultsSatia: null,
    NoInternetDialogSatia: false,
    isLoadingSatia: false,
})


export const serviceActionPendingCity = () => ({
    type: typeExport.SPLASH_SATIA_SERVICE_PENDING_CITY,
    NoInternetDialogCity: false,
    isLoadingCity: true,
    error: false,
    showDialohCity: false

})

export const serviceActionErrorCity_CITY = (error) => ({
    type: typeExport.SPLASH_SATIA_SERVICE_ERROR_CITY,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccessGetCityData = (data) => ({
    type: typeExport.SERVICE_SUCCESS_GET_CITY_DATA,
    NoInternetDialog: false,
    results_City: data,
    showDialohCity: true,
    isLoading: false,
})
export const serviceActionSetToken = (token) => ({
    type: typeExport.SERVICE_TOKEN,
    token: token,
})
export const serviceActionSetUser = (user) => ({
    type: typeExport.SERVICE_USER,
    user: user,
})
export const serviceActionSetWallet = (data, typeWallet) => ({
    type: typeExport.SERVICE_WALLET,
    wallet: data,
    typeWallet: typeWallet,
})


export const serviceActionSetIdCity = (data) => ({
    type: typeExport.SERVICE_CITY,
    idCity: data,
})
export const serviceActionAddCart = (data, methd) => ({
    type: typeExport.SERVICE_ADD_CART,
    product: data,
    methd: methd,
})
export const serviceActionSubCart = (data) => ({
    type: typeExport.SERVICE_SUB_CART,
    product: data,
})
export const serviceActionPriceAll = () => ({
    type: typeExport.SERVICE_PRICE_ALL,
})
export const serviceActionClearAllCart = () => ({
    type: typeExport.SERVICE_CLEAR_ALL_CART,
})

export const serviceActionChangeItemDiscount = () => ({
    type: typeExport.SERVICE_CHANGE_ITEM_DISCOUNT_FIRST,
})
export const serviceActionRestaurantBasketCheck = (data) => ({
    type: typeExport.SERVICE_RestaurantBasketCheck,
    data: data,
})
export const serviceActionRtl = (data) => ({
    type: typeExport.SERVICE_Rtl,
    data: data,
})

export const serviceActionLang = (data) => ({
    type: typeExport.SERVICE_Lang,
    data: data,
})
export const serviceActionBackground = (data) => ({
    type: typeExport.SERVICE_Background,
    data: data,
})

export const serviceActionChangeNotifUser = (data) => ({
    type: typeExport.SERVICE_ChangeNotifUser,
    data: data,
})
export const serviceActionTokenFirebase = (data) => ({
    type: typeExport.SERVICE_TokenFirebase,
    data: data,
})

export const serviceActionSetState = (data) => ({
    type: typeExport.SERVICE_STATE,
    STATE: data,
})

export const serviceActionSetConnectionType = (data) => ({
    type: typeExport.SERVICE_ConnectionType,

    ConnectionType: data,
})
export const serviceActionSetIsConnected = (data) => ({
    type: typeExport.SERVICE_Connection,

    Connection: data,
})
export const serviceActionSetwifiIsEnabled = (data) => ({
    type: typeExport.SERVICE_wifiIsEnabled,

    wifiIsEnabled: data,
})
export const serviceActionSetwifiConnectionStatus = (data) => ({
    type: typeExport.SERVICE_wifiConnectionStatus,

    wifiConnectionStatus: data,
})
export const serviceActionSetConnectionInternetHotspot = (data) => ({
    type: typeExport.SERVICE_ConnectionInternetHotspot,

    ConnectionInternetHotspot: data,
})
export const serviceActionSetLocation = (data) => ({
    type: typeExport.SERVICE_Location,

    Location: data,
})
export const serviceActionSetTypeLogin = (data) => ({
    type: typeExport.SERVICE_TypeLogin,

    TypeLogin: data,
})
export const serviceActionListNotSendMyApply = (data, index) => ({
    type: typeExport.SERVICE_ListNotSendMyApply,

    ListNotSendMyApply: data,
    indexListNotSendMyApply: index,
})
export const serviceActionNotSendListOperatorApply = (data, index) => ({
    type: typeExport.SERVICE_NotSendListOperatorApply,


    NotSendListOperatorApply: data,
    indexNotSendListOperatorApply: index,
})
export const serviceActionListNotSendRegisterComplaints = (data, index) => ({
    type: typeExport.SERVICE_ListNotSendRegisterComplaints,

    ListNotSendRegisterComplaints: data,
    indexListNotSendRegisterComplaints: index,
})
export const serviceActionAccount = (data, index) => ({
    type: typeExport.SERVICE_Account,

    Account: data,
    indexAccount: index,
})
export const serviceActionSetTimeSpan = (beginDate, endDate, indexSelectMonthType, month) => ({
    type: typeExport.SERVICE_TIME_SPAN,
    beginDate: beginDate,
    endDate: endDate,
    month: month,
    indexSelectMonthType: indexSelectMonthType,
})
export const serviceActionSetUserPassWifi = (data) => ({
    type: typeExport.SERVICE_UserPassWifi,

    data: data,

})
export const serviceActionSetNameDynamic = (name, data) => ({
    type: typeExport.SERVICE_NameDynamic,

    name: name,
    data: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(SplashSatiaScreen);
